import { Box, InputAdornment, makeStyles } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { IoIosSearch } from "react-icons/io";

import useTabStyles from "../../../styles/Tab.style";
import { AddCountryWrapper } from "../../../tab-panels/countries/components/AddCountryWrapper";
import { AppScrollbar } from "../../../../../components/scrollbar/AppScrollbar";
import { InputField } from "../../../../../components/input-field/InputField";
import Paginator from "../../../../../models/Paginator";
import { AddRequestCountryAttributes } from "../../../../../attributes/country-attributes";
import PaginationActions from "../../../components/CountryPaginationActions";

const useStyles = makeStyles(
  (theme) => ({
    navBar: {
      position: "absolute",
      left: 0,
      top: 0,
      zIndex: 1000,

      height: "calc(100vh - 102px)",
      width: 500,
      borderRight: "1px solid #e8e8e8",
      overflow: "hidden",
    },

    navBarHeader: {
      padding: `${theme.spacing(2)}px 0px`,
    },

    navBarHeaderSearch: {
      padding: `0px ${theme.spacing(4)}px`,
    },

    navBarHeaderPagination: {
      padding: `0px ${theme.spacing(2)}px`,
    },

    navBarMenuWrapper: {
      height: "calc(100vh - 236px)",
    },
  }),
  {
    name: "country-list-styles",
    flip: null,
  }
);

export interface CountryListProps {
  countries: Array<AddRequestCountryAttributes>;
  callback: (
    paginator: Paginator,
    countries: Array<AddRequestCountryAttributes>
  ) => void;
}

export const CountryList = (props: CountryListProps) => {
  const classes = useStyles(props);
  const tabClasses = useTabStyles(props);
  const intl = useIntl();
  // Props
  const { countries, callback } = props;
  // State
  const [country, setCountry] = useState(null);
  const [filterCountries, setFilterCountries] = useState(
    (): Array<AddRequestCountryAttributes> => countries
  );
  const [page, setPage] = React.useState(0);
  // Locals variables
  const rowsPerPage = 50;

  // Callback

  const handleChangePage = (page: number) => {
    setPage(page);
  };

  const searchFilter = (query: string) => {
    if (query !== "") {
      const results = countries.filter(
        (country: AddRequestCountryAttributes) => {
          let searchCountryName = country.country_designation
            .toLowerCase()
            .startsWith(query.toLowerCase());
          let searchCountryCode = country.country_dc
            .toLowerCase()
            .startsWith(query.toLowerCase());

          return (
            searchCountryName ||
            searchCountryCode ||
            (country.currency_designation != null &&
              country.currency_designation
                .toLowerCase()
                .startsWith(query.toLowerCase()))
          );
        }
      );
      setFilterCountries(results);
    } else {
      setFilterCountries(countries);
    }
  };

  const handleCountryClick = (country: any) => {
    setCountry(country);
  };

  // Renders

  useEffect(() => {
    if (countries.length !== filterCountries.length) {
      setFilterCountries([...countries]);
    }

    // eslint-disable-next-line
  }, [countries]);

  return (
    <Box className={classes.navBar}>
      <AddCountryWrapper
        show={country !== null}
        country={country}
        onClose={() => setCountry(null)}
        callback={(country, countries) => callback(country, countries)}
      />

      <Box
        component="div"
        className={classes.navBarHeader}
        display="flex"
        alignItems="center"
      >
        <Box component="div" width="100%">
          <Box component="div" className={classes.navBarHeaderSearch}>
            <InputField
              id="search_team"
              name="search_team"
              fullWidth
              label=""
              placeholder={intl.formatMessage({
                id: "sharedScreen.filterBusinessName",
              })}
              endAdornment={
                <InputAdornment position="end">
                  <IoIosSearch />
                </InputAdornment>
              }
              type="text"
              onChange={(event) => searchFilter(event.target.value)}
            />
          </Box>
          <Box component="div" className={classes.navBarHeaderPagination}>
            <PaginationActions
              count={filterCountries.length}
              onChangePage={handleChangePage}
              page={page}
              rowsPerPage={rowsPerPage}
            />
          </Box>
        </Box>
      </Box>

      <AppScrollbar>
        <Box component="div" className={classes.navBarMenuWrapper}>
          <Box component="ul" className={tabClasses.navBarMenu}>
            {(rowsPerPage > 0
              ? filterCountries.slice(
                  page * rowsPerPage,
                  page * rowsPerPage + rowsPerPage
                )
              : filterCountries
            ).map((item, index) => {
              return (
                <Box
                  component="li"
                  display="flex"
                  alignItems="center"
                  justifyContent="space-between"
                  className={`item ${
                    country !== null && country.alpha_code === item.alpha_code
                      ? "selected"
                      : ""
                  }`}
                  key={index}
                  onClick={(_) => handleCountryClick(item)}
                >
                  <Box
                    display="flex"
                    alignItems="center"
                    className="leftWrapper"
                  >
                    <Box component="span">{item.country_designation}</Box>
                    <Box component="span">({item.alpha_code})</Box>
                  </Box>

                  <Box component="span">{item.currency_code}</Box>
                </Box>
              );
            })}
          </Box>
        </Box>
      </AppScrollbar>
    </Box>
  );
};
